import React from 'react';
import PropTypes from 'prop-types';

import Route from './Route';
import { sortApiRoutes } from '../../helpers/helpers';

class Category extends React.PureComponent {

	componentDidMount() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	componentDidUpdate() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	render() {
		const { category } = this.props;
		const sorted = sortApiRoutes(category.routes);
		return (

			<div className="category">
				<h2>{category.name}</h2>

				<p className="summary">{category.summary}</p>

				{category.notes &&
					<p className="notes">{category.notes}</p>
				}

				{/* Routes */}
				<div className="routes">
					{sorted.map(route => <Route key={`${route.verbs[0]}-${route.name[0]}`} route={route} />)}
				</div>
			</div>
		);
	}
}

Category.propTypes = {
	category: PropTypes.object.isRequired
};

export default Category;


// WEBPACK FOOTER //
// ./src/components/api/Category.js